module.exports = __webpack_public_path__ + "static/media/4.9c0e1f80.jpg";